<template>
  <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">
    <el-breadcrumb-item>{{
      title1
    }}</el-breadcrumb-item>
    <el-breadcrumb-item v-if="currentRoutePage != '/index' && currentRoutePage != '/deviceAnalysis/index'&& currentRoutePage != '/device/deviceInsight' && currentRoutePage != '/gatherUnit'">{{
      activeLang == "zh" ||
      $t("menu." + curMenu2.code) == null ||
      $t("menu." + curMenu2.code) == undefined
        ? curMenu2.name == undefined
          ? ""
          : curMenu2.name
        : curMenu2.code == undefined
        ? ""
        : $t("menu." + curMenu2.code)
    }}</el-breadcrumb-item>
    <!-- <el-breadcrumb-item>空压机型号管理</el-breadcrumb-item> -->
  </el-breadcrumb>
</template>

<script>
import { mapGetters } from "vuex";
import {
  setItemToLocalstorage,
  delItemFormLocalstorage,
  getItemFormLocalstorage,
} from "../../../../utils/package-localstorage";
export default {
  name: "index",
  data() {
    return {
      menu1: "",
      menu2: "",
      curMenu: {},
      curMenu2: {},
      currentRoutePage: "",
      brand: "IR",
      welcomespeech: "Welcome to HELIX",
      title1:"",
    };
  },
  async created() {
    
    this.brand = localStorage.getItem("user_brand");
    if (this.brand == "IR") {
      this.welcomespeech = "Welcome to HELIX";
    } else if (this.brand == "GD") {
      this.welcomespeech = "Welcome to iConn";
    } else {
      this.welcomespeech = "Welcome to HELIX";
    }
  },
  async mounted() {
    let that = this;
    that.currentRoutePage = that.$route.fullPath.split('?')[0];
    this.getNavBar();
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
      menuListState: "menuListState",
    }),
  },
  methods: {
    getNavBar() {
      var menuList = getItemFormLocalstorage("menuData"); //this.menuListState;// getItemFormLocalstorage("menuData");
      var curRoute = this.$route.fullPath;
      var curMenu = null;
      menuList.forEach((item) => {
        if (item.url == curRoute) curMenu = item;
      });
      if (
        curMenu == null ||
        curMenu.name == undefined ||
        curMenu.name == null
      ) {
        menuList.forEach((item) => {
          if (
            item.children != undefined &&
            item.children != null &&
            item.children.length > 0
          )
            item.children.forEach((item2) => {
              if (item2.url == curRoute) curMenu = item;
            });
        });
      }
      // var curMenu = menuList.find((item) => {
      //   return item.url === curRoute;
      // });
      // if (curMenu == undefined || curMenu == null) {
      //   curMenu = menuList.find((item) => {
      //     return item.children == undefined
      //       ? false
      //       : item.children == item.children.some((x) => x.url === curRoute);
      //   });
      // }
      if (curMenu) {
        // if (curMenu.name == "首页") {
        //   curMenu.name = "Welcome to HELIX";
        // }
        this.curMenu = curMenu;
        this.menu1 = curMenu.name;
        var curMenu2 = curMenu.children.find((x) => x.url == curRoute);
        if (curMenu2 != undefined && curMenu2 != null) {
          this.curMenu2 = curMenu2;
          this.menu2 = curMenu2.name;
        }
        this.title1=(this.activeLang == "zh" ||
        this.$t("menu." + curMenu.code) == null ||
        this.$t("menu." + curMenu.code) == undefined
        ? this.curMenu.name == "首页"
          ? this.welcomespeech
          : this.curMenu.name
        : this.curMenu.name === "首页"
        ? this.welcomespeech
        : this.$t("menu." + curMenu.code));
      }else if (this.$route.path == "/device/deviceInsight") {
        this.title1 = this.$t("title.deviceInsight")
      }else if (this.$route.path == "/gatherUnit") {
        this.title1 = this.$t("menu.GatherUnit_View")
      }
    },
  },
};
</script>

<style>
</style>